import { Injectable } from '@angular/core';
import { HttpClientService } from './httpClient/httpclient.service';

@Injectable()
export class ReportUserService {

  baseUrl = HttpClientService.BASE_MS_AUTH;

  constructor(private http: HttpClientService) { }

  /**
   * Metodo per ottenere report di company e application
   * @param showUsers un boolean per decidere se visualizzare o meno gli utenti
   * @returns
   */
  getReportCompanyApp(showUsers: boolean) {
    return this.http.get(`${this.baseUrl}/report/companies?showUsers=` + showUsers);
  }

  /**
   * Metodo per ottenere i ruoli dello schema auth
   * @returns
   */
  getAuthRole() {
    return this.http.get(`${this.baseUrl}/report/auth-role`).map(res => res.map(r => ({label: `${r.descr}`, value: `${r.type}`})));
  }

  /**
   * Metodo per ottenere gli utenti
   * @returns
   */
  getUsers() {
    return this.http.get(`${this.baseUrl}/users?limit=9999`).map(res => res.map(r => ({label: `${r.login}`, value: `${r.id}`})));
  }

  /**
   * Metodo per ottenere le Company
   * @returns
   */
  getCompanies() {
    return this.http.get(`${this.baseUrl}/companies`).map(res => res.map(r => ({label: `${r.name}`, value: `${r.id}`})));
  }

  /**
   * Metodo per ottenere le Applications
   * @returns
   */
  getApplications() {
    return this.http.get(`${this.baseUrl}/applications`).map(res => res.map(r => ({label: `${r.name}`, value: `${r.id}`})));
  }

  /**
   * Metodo per ottenere report Utenti, company e Application
   * @param role filtro ruolo
   * @param user filtro utente
   * @param company filtro company
   * @param application filtro application
   * @returns
   */
  getReportUserCompanyApp(role, user, company, application) {
    if (role == null && user == null && company == null && application == null) {
      return this.http.get(`${this.baseUrl}/report/user-company-app`);
    } else {
      const userParams: Array<{key: string, value: string}> = [];

      if (role != null) {
        userParams.push({key: 'role', value: role});
      }

      if (user != null) {
        userParams.push({key: 'user', value: user});
      }

      if (company != null) {
        userParams.push({key: 'company', value: company});
      }

      if (application != null) {
        userParams.push({key: 'application', value: application});
      }

      const param = HttpClientService.buildListParams(null, null, userParams, null, null, null, null);
      return this.http.get(`${this.baseUrl}/report/user-company-app` + '?' + param.toString());
    }
  }

  /**
   * Metodo per ottenere report utenti e ruoli
   * @param company filtro id company
   * @param user filtro utente
   * @param login filtro login
   * @param email filtro email
   * @returns
   */
  getReportUserRoles(company, user, login, email) {
    if (user == null && login == null && email == null) {
      return this.http.get(`${this.baseUrl}/report/user-roles/${company}`);
    } else{
      const userParams: Array<{key: string, value: string}> = [];

      if (user != null) {
        userParams.push({key: 'user', value: user});
      }

      if (login != null) {
        userParams.push({key: 'login', value: login});
      }

      if (email != null) {
        userParams.push({key: 'email', value: email});
      }

      const param = HttpClientService.buildListParams(null, null, userParams, null, null, null, null);
      return this.http.get(`${this.baseUrl}/report/user-roles/${company}` + '?' + param.toString());
    }
  }

  /**
   * Metodo per ottenere report Ruoli e permission relative
   * @param company filtro company
   * @returns
   */
  getReportRolesPermission(company) {
    return this.http.get(`${this.baseUrl}/report/role-operations/${company}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/report-user.service.ts